const numberRegex = /[0-9]/;
const lowerCaseRegex = /[a-z]/;
const upperCaseRegex = /[A-Z]/;

const isValidPassword = (password: string) => {
  if (!passwordContainsNumber(password)) {
    return false;
  }
  if (!passwordContainsLower(password)) {
    return false;
  }
  if (!passwordContainsUpper(password)) {
    return false;
  }
  if (!passwordIsLongEnough(password)) {
    return false;
  }
  return true;
};

const passwordContainsNumber = (password: string) => numberRegex.test(password);

const passwordContainsLower = (password: string) => lowerCaseRegex.test(password);

const passwordContainsUpper = (password: string) => upperCaseRegex.test(password);

const passwordIsLongEnough = (password: string) => password.length >= 8;

export {
  isValidPassword,
  passwordContainsNumber,
  passwordContainsLower,
  passwordContainsUpper,
  passwordIsLongEnough,
};
